import { ROUTES } from '@shared/utils';
import { BackChevron } from '../../BackChevron/BackChevron';

type MagazineCategoryHeaderProps = {
  categoryName: string;
};

function MagazineCategoryHeader({ categoryName }: MagazineCategoryHeaderProps) {
  return (
    <div className="flex items-center gap-4" data-testid="magazine-category-header">
      <BackChevron fallbackUrl={ROUTES.MAGAZINE.HOME} />
      <h1 className="heading-5 text-foreground">{categoryName}</h1>
    </div>
  );
}

export { MagazineCategoryHeader, type MagazineCategoryHeaderProps };
